import RegisterAPI from '@/app/apis/main/register/register-api.js';

export default {
    /**
     * @param {*} registrationDetails
     */
    async postRegister(registrationDetails) {
        return RegisterAPI.postRegister(registrationDetails);
    }
}